import React from 'react';
import './FollowUsPage.css';

export default function FollowUsPage() {
  return (
    <div className="follow-container">
      <h1>Follow ChronoTech Robotics</h1>
      <p className="follow-sub">
        Stay connected with our latest classes, builds, updates, and robotics innovation.
      </p>

      <div className="follow-grid">
        <div className="follow-card">
          <img src="/images/youtube.png" alt="YouTube" />
          <h2>YouTube</h2>
          <p>Watch our class highlights, tutorials, and upcoming product demos.</p>
          <a href="https://www.youtube.com/@ChronoTechRobotics" target="_blank" rel="noreferrer">
            Visit YouTube →
          </a>
        </div>

        <div className="follow-card">
          <img src="/images/facebook.png" alt="Facebook" />
          <h2>Facebook</h2>
          <p>See behind-the-scenes updates, new launches, and share your child’s creations.</p>
          <a href="https://www.facebook.com/profile.php?id=61577194771202" target="_blank" rel="noreferrer">
            Visit Facebook →
          </a>
        </div>
      </div>
    </div>
  );
}
